import { gql } from "../__generated__/gql";

gql(`
    fragment AmendmentPayrollDateResultFields on AmendmentPayrollDateResult {
        date
        isValid
    }
`);

gql(`
    fragment AmendmentValidDatesResultFields on AmendmentValidDatesResult {
        minDate
        maxDate
        hasDateRestriction
        payrollDates {
            ...AmendmentPayrollDateResultFields
        }
    }
`);

gql(`
    fragment MissionAmendmentFields on MissionAmendment {
        id
        missionId
        state
        applyDate
        createdAt
        updatedAt
        submittedAt
        rejectedAt
        rejectedReason
        canceledAt
        canceledReason
        changes {
            ...MissionAmendmentChangeFields
        }
        missionInfo {
            ...MissionInfoFields
        }
        signatureModel
        signingState
        signatureStatus
        workerAmendmentSignedAt
        clientAmendmentSignedAt
        workerAmendmentSealedAt
        clientAmendmentSealedAt
        amendmentEffectiveAsset {
            ...AssetFields
        }
    }
`);

gql(`
    fragment MissionAmendmentChangeFields on MissionAmendmentChange{
        field
        oldValue
        newValue
    }
`);

export const CREATE_AMENDMENT = gql(`
    mutation CreateAmendment($input: CreateAmendmentInput!) {
        createAmendment(
            input: $input
        ) {
            ...MissionAmendmentFields
        }
    }
`);

export const UPDATE_AMENDMENT = gql(`
    mutation UpdateAmendment($amendmentId: ID!, $input: UpdateAmendmentInput!) {
        updateAmendment(
            amendmentId: $amendmentId,
            input: $input
        ) {
            ...MissionAmendmentFields
        }
    }
`);

export const DELETE_AMENDMENT = gql(`
    mutation DeleteAmendment($amendmentId: ID!) {
        deleteAmendment(
            amendmentId: $amendmentId
        )
    }
`);

export const SUBMIT_AMENDMENT = gql(`
    mutation SubmitAmendment($amendmentId: ID!) {
        submitAmendment(
            amendmentId: $amendmentId
        ) {
            ...MissionAmendmentFields
        }
    }
`);

export const CANCEL_AMENDMENT = gql(`
    mutation CancelAmendment($amendmentId: ID!, $reason: String!) {
        cancelAmendment(
            amendmentId: $amendmentId,
            reason: $reason
        ) {
            ...MissionAmendmentFields
        }
    }
`);

export const REJECT_AMENDMENT = gql(`
    mutation RejectAmendment($amendmentId: ID!, $reason: String!) {
        rejectAmendment(
            amendmentId: $amendmentId,
            reason: $reason
        ) {
            ...MissionAmendmentFields
        }
    }
`);

export const GET_MISSION_AMENDMENTS = gql(`
    query getMissionAmendments($missionId: ID!, $includeRejected: Boolean) {
        getMissionAmendments(missionId: $missionId, includeRejected: $includeRejected) {
            ...MissionAmendmentFields
        }
    }
`);

export const GET_VALID_AMENDMENT_APPLY_DATES = gql(`
    query GetValidAmendmentApplyDates($missionId: ID!, $data: AmendmentValidDatesInput!) {
        getValidAmendmentApplyDates(missionId: $missionId, data: $data) {
            ...AmendmentValidDatesResultFields
        }
    }
`);

export const GET_AMENDMENT = gql(`
    query getAmendment($id: ID!) {
        getAmendment(amendmentId: $id) {
            ...MissionAmendmentFields
        }
    }
`);

export const CHANGE_AMENDMENT_SIGNER = gql(`
    mutation ChangeAmendmentSigner(
        $amendmentId: ID!
        $clientUserId: ID!
    ) {
        changeAmendmentSigner(
            amendmentId: $amendmentId
            clientUserId: $clientUserId
        ) {
            ...MissionAmendmentFields
        }
    }
`);
